import { render, staticRenderFns } from "./reports-legend-categories.vue?vue&type=template&id=6db2312b&scoped=true"
import script from "./reports-legend-categories.vue?vue&type=script&lang=js"
export * from "./reports-legend-categories.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-categories.vue?vue&type=style&index=0&id=6db2312b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2312b",
  null
  
)

export default component.exports